const hostname = window.location.hostname;
const hostnameParts = hostname.split(".");
const NODE_ENV = process.env.NODE_ENV;

// Origins selectable from the dashboard's "Data source" switcher (super admins only).
// Defaults to prod. "local" is only offered when running the dev server (`npm run dev`/`npm start`).
export const API_ORIGINS = {
  prod: "https://api.lenny.ai/",
  staging: "https://api-scholarship.lenlen.ai/",
  ...(NODE_ENV === "development" ? { local: "http://localhost:3000/" } : {}),
};
export const DEFAULT_API_ORIGIN = "prod";
const API_ORIGIN_STORAGE_KEY = "api_origin";

export const getApiOrigin = () => {
  const stored = localStorage.getItem(API_ORIGIN_STORAGE_KEY);
  // return  DEFAULT_API_ORIGIN;
  return API_ORIGINS[stored] ? stored : DEFAULT_API_ORIGIN;
};

export const setApiOrigin = (key) => {
  if (API_ORIGINS[key]) {
    localStorage.setItem(API_ORIGIN_STORAGE_KEY, key);
  }
};

export const tenant =
  NODE_ENV === "development"
    ? ""
    : hostnameParts.length === 3
      ? hostnameParts[0]
      : null;
// export const tenant = null;
export const isTenant = !!tenant;

localStorage.setItem("isTenant", isTenant);
localStorage.setItem("tenant", tenant);
export const tenantId = (tenantId) => {
  if (tenantId) {
    localStorage.setItem("tenantId", tenantId);
  }
  return localStorage.getItem("tenantId");
};

const activeOrigin = API_ORIGINS[getApiOrigin()];

export const env = {
  APP_NAME: "Application",
  API_ENDPOINT_URL: activeOrigin,
  B2B_API_ENDPOINT_URL: activeOrigin,
  SUPER_ADMIN_API_ENDPOINT_URL: activeOrigin,
  TENANT_API_ENDPOINT_URL: activeOrigin,
  FRONTEND_DOMAIN: "localhost",
};
